module.exports = __webpack_public_path__ + "static/media/phila_tuna.e0a0ae89.webp";